import { render, staticRenderFns } from "./HasIngredientWithSugarAdded.vue?vue&type=template&id=026235fd&scoped=true"
import script from "./HasIngredientWithSugarAdded.vue?vue&type=script&lang=ts"
export * from "./HasIngredientWithSugarAdded.vue?vue&type=script&lang=ts"
import style0 from "./HasIngredientWithSugarAdded.vue?vue&type=style&index=0&id=026235fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026235fd",
  null
  
)

export default component.exports